export const syncFavicon = (faviconUrl) => {
  if (!faviconUrl || typeof document === 'undefined') {
    return;
  }

  const head = document.head || document.getElementsByTagName('head')[0];
  if (!head) {
    return;
  }

  const currentIcons = head.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
  currentIcons.forEach((iconNode) => {
    iconNode.parentNode?.removeChild(iconNode);
  });

  const makeIconNode = (rel) => {
    const iconNode = document.createElement('link');
    iconNode.setAttribute('rel', rel);
    iconNode.setAttribute('href', faviconUrl);
    head.appendChild(iconNode);
  };

  makeIconNode('icon');
  makeIconNode('shortcut icon');
};